import RecipeImage from '~/components/Recipes/RecipeImage.tsx'

export default function RecipeSmallCard({
	recipe,
	showUser,
}: {
	recipe: any
	showUser?: boolean
}) {
	const { title, imageId, owner } = recipe
	return (
		<>
			{imageId ? (
				<div className="block h-full w-full flex-1 overflow-hidden rounded-t-sm border border-secondary pb-3">
					{showUser ? (
						<div className="absolute top-4 w-full truncate bg-background px-3 py-1 text-center text-sm opacity-90 group-hover:text-foreground-medium sm:text-right">
							@{owner.username}
						</div>
					) : null}
					<RecipeImage
						type="card"
						publicId={imageId}
						className="group-hover:opacity-75"
					/>
					<p className="pointer-events-none line-clamp-2 justify-end border-t bg-white px-4 pt-3 text-center font-sans text-lg font-medium group-hover:text-foreground-medium">
						{title}
					</p>
				</div>
			) : (
				<div className="relative flex h-full min-h-[200px] w-full items-center rounded-sm border-8 border-secondary">
					{showUser ? (
						<div className="absolute top-2 w-full truncate px-4 py-2 text-right text-sm group-hover:text-foreground-medium">
							@{owner.username}
						</div>
					) : null}
					<p className="pointer-events-none m-auto bg-white px-4 text-center font-sans text-lg font-medium group-hover:text-foreground-medium">
						{title}
					</p>
				</div>
			)}
		</>
	)
}
